// 3rd-party modules
import { Navigate, RouteObject, useRoutes } from 'react-router-dom';

// project modules
import AccountPaymentReturnPage from './pages/AccountPaymentReturnPage';
import DefaultLayout from './layouts/DefaultLayout';
import EmptyLayout from './layouts/EmptyLayout';
import LoginPage from './pages/auth/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import TemplatePage from './pages/template';
import SignupPage from './pages/auth/SignupPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import EmailConfirmationPage from './pages/auth/EmailConfirmationPage';
import AccountPage from './pages/portal/AccountPage';
import PortalLayout from './layouts/PortalLayout';
import EmailNotConfirmedPage from './pages/auth/EmailNotConfirmedPage';
import CreateNewSubscriptionPage from './pages/auth/CreateNewSubscriptionPage';
import HelpDeskPage from './pages/portal/HelpDeskPage';
import ProfilesListPage from './pages/portal/ProfilesListPage';
import DevicesListPage from './pages/portal/DevicesListPage';
import FiltersPage from './pages/portal/FiltersPage';
import DashPage from './pages/portal/DashPage';
import HomePage from './pages/portal/HomePage';
import TestPage from './pages/portal/TestPage';
import VpnPage from './pages/portal/VpnPage';
import DnsPage from './pages/portal/DnsPage';

export default function AppRouter() {
  const routes: RouteObject[] = [
  {
    path: 'auth',
    element: <DefaultLayout />,
    children: [
      { path: 'login', element: <LoginPage /> },
      { path: 'forgot-password', element: <ForgotPasswordPage /> },
      { path: 'signup', element: <SignupPage /> },
    ]
  },
  {
    path: '/not-confirmed-email',
    element: <DefaultLayout />,
    children: [
      { path: '', element: <EmailNotConfirmedPage /> },
    ]
  },
  {
    path: '/reset-password',
    element: <DefaultLayout />,
    children: [
      { path: '', element: <ResetPasswordPage /> },
    ]
  },
  {
    path: '/email-confirmation',
    element: <DefaultLayout />,
    children: [
      { path: '', element: <EmailConfirmationPage /> },
    ]
  },
  {
    path: '/payment',
    element: <DefaultLayout />,
    children: [
      { path: 'return', element: <AccountPaymentReturnPage /> },
    ]
  },
  {
    path: '/portal',
    element: <PortalLayout />,
    children: [
      { path: '', element: <ProtectedRoute><HomePage /></ProtectedRoute> },
      { path: 'test', element: <ProtectedRoute><TestPage /></ProtectedRoute> },
      { path: 'profiles', element: <ProtectedRoute><ProfilesListPage /></ProtectedRoute> },
      { path: 'devices', element: <ProtectedRoute><DevicesListPage /></ProtectedRoute> },
      { path: 'filters', element: <ProtectedRoute><FiltersPage /></ProtectedRoute> },
      { path: 'create-new-subscription', element: <ProtectedRoute><CreateNewSubscriptionPage /></ProtectedRoute> },
      { path: 'support-tickets', element: <ProtectedRoute><HelpDeskPage /></ProtectedRoute> },
      { path: 'account-details', element: <ProtectedRoute><AccountPage /></ProtectedRoute> },
      { path: 'dash', element: <ProtectedRoute><DashPage /></ProtectedRoute> },
      { path: 'vpns', element: <ProtectedRoute><VpnPage /></ProtectedRoute> },
      { path: 'dns', element: <ProtectedRoute><DnsPage /></ProtectedRoute> },
    ]
  },
  {
    index: true,
    element: <Navigate to="/portal" replace />
  }
];

  if (process.env.NODE_ENV === 'development') {
    routes.push({
        path: '/template',
        element: <EmptyLayout />,
        children: [
          { path: '', element: <TemplatePage /> }
        ]
    });
  }

  routes.push({
    path: '*',
    element: <NotFoundPage />
  });

  return useRoutes(routes);
}
